import { renderLoginComponent } from '../components/Login';
import { renderCasesTable } from '../components/CasesTable/CasesTable.mjs';
import { getCaseDetailMarkup } from './caseDetail.mjs';
import { getCaseActionsFromSource, runCaseAction } from './caseActions.mjs';

const CASE_DETAIL_MIN_LOADING_MS = 1000;
const caseDetailMarkupCache = new Map();
let casesTableApi = null;
let allCases = [];
let showClosedCases = false;
const detailCellCleanupMap = new WeakMap();

const CLOSED_CASE_STATES = [
  "Řízení bylo ukončeno",
  "Mylné řízení",
  "Řízení bylo uzavřeno jako mylné",
  "Řízení bylo postoupeno jinému pracovišti",
  "Řízení ukončeno"
];

function fetchNemovitostiMujPortal() {
  fetch("/nemovitostiMujPortal")
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      let table = document.getElementById("nemovitostiMujPortalTable");
      const tableHeaderRowCount = 1;
      const rowCount = table.rows.length;
      for (var i = tableHeaderRowCount; i < rowCount; i++) {
        table.deleteRow(tableHeaderRowCount);
      }

      data.forEach(function (object) {
        const tr = document.createElement("tr");
        tr.innerHTML =
          "<td>" +
          object.katuze +
          "</td>" +
          '<td><a href=# target="popup" onclick="window.open(`/Nahlizeni?typ=' +
          object.typ +
          "&id=" +
          object.id +
          '`,`name`,`width=1000,height=700`)">' +
          object.identifikace + 
          "</a>" + '&nbsp;<gov-icon class="mujKatastrTdIcon" type="basic" name="box-arrow-up-right"></gov-icon>' + "</td>" +
          "<td>" +
          object.podil +
          "</td>" +
          "<td>" +
          object.cisloLv +
          "</td>" +
          "<td>" +
          object.povinnosti +
          "</td>";
        //'<td>' + object.prava + '</td>' ;

        table.appendChild(tr);
      });
      if (data.length === 0) {
        const tr = document.createElement("tr");
        tr.innerHTML = '<td colspan="5">Není evidováno žádné vlastnictví</td>';
        table.appendChild(tr);
      }
    });
}

function fetchJpvProMujPortal() {
  fetch("/MujPortalJpvPro")
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      let table = document.getElementById("jpvProMujPortalTable");
      const tableHeaderRowCount = 1;
      const rowCount = table.rows.length;
      for (var i = tableHeaderRowCount; i < rowCount; i++) {
        table.deleteRow(tableHeaderRowCount);
      }

      data.forEach(function (object) {
        const tr = document.createElement("tr");
        tr.innerHTML =
          "<td>" +
          object.prava +
          "</td>" +
          "<td>" +
          object.katuze +
          "</td>" +
          "<td>" +
          object.identifikace +
          "</td>" +
          '<td style="text-align: right;">' +
          object.cisloLv +
          "</td><td></td>";
        //'<td>' + object.prava + '</td>' ;

        table.appendChild(tr);
      });
      if (data.length === 0) {
        const tr = document.createElement("tr");
        tr.innerHTML = '<td colspan="5">Nejsou evidována žádná oprávnění</td>';
        table.appendChild(tr);
      }
    });
}

function fetchDalsiZapisyMujPortal() {
  fetch("/MujPortalDalsiZapisy")
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      let table = document.getElementById("dalsiZapisyMujPortalTable");
      const tableHeaderRowCount = 1;
      const rowCount = table.rows.length;
      for (var i = tableHeaderRowCount; i < rowCount; i++) {
        table.deleteRow(tableHeaderRowCount);
      }

      data.forEach(function (object) {
        const tr = document.createElement("tr");
        tr.innerHTML =
          "<td>" +
          object.povinnosti +
          "</td>" +
          "<td>" +
          object.katuze +
          "</td>" +
          "<td>" +
          object.identifikace +
          "</td>" +
          '<td style="text-align: right;">' +
          object.cisloLv +
          "</td>" +
          '<td style="text-align: right;">' +
          object.podil +
          "</td>";

        //'<td>' + object.prava + '</td>' ;

        table.appendChild(tr);
      });
      if (data.length === 0) {
        const tr = document.createElement("tr");
        tr.innerHTML =
          '<td colspan="5">Nejsou evidovány žádné další zápisy</td>';
        table.appendChild(tr);
      }
    });
}

function fetchMujPortalPoznamkaProOs() {
  fetch("/MujPortalPoznamkaProOs")
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      let table = document.getElementById("poznamkyProOsPortalTable");
      const tableHeaderRowCount = 1;
      let rowCount = 0;
      if (table != null) rowCount = table.rows.length;
      for (var i = tableHeaderRowCount; i < rowCount; i++) {
        table.deleteRow(tableHeaderRowCount);
      }

      if (data.length !== 0) {
        const tr = document.createElement("tr");
        tr.innerHTML =
          '<td style="color: red;"><b>K Vaší osobě je zapsáno ' +
          data.join(", ") +
          "</b></td>";
        table.appendChild(tr);
      }
    });
}

async function fetchRawCases() {
  const response = await fetch('/rizeni');
    if (!response.ok) {
        throw new Error('Failed to fetch cases');
    }
    return await response.json();
}

/* TABLE + MODAL HELPERS BEGIN */

const TABLE_COLUMNS = [
  { key: "cisloRizeni", label: "Číslo řízení", hideMobile: false },
  { key: "datum", label: "Datum podání", hideMobile: true },
  { key: "stavNahlizeni", label: "Stav", hideMobile: true },
  { key: "__actions", label: "", hideMobile: false, sortable: false },
];

function resolveCaseIdentifier(source) {
  if (!source) return null;
  if (typeof source === 'string' || typeof source === 'number') return String(source);
  return source.id ?? source.cisloRizeni ?? source.cislo_rizeni ?? null;
}

async function loadCaseDetailMarkupForRow(row) {
  const caseId = resolveCaseIdentifier(row);
  if (!caseId) {
    return '<div class="case-detail case-detail--empty">Detail se nepodařilo načíst.</div>';
  }
  if (caseDetailMarkupCache.has(caseId)) {
    return caseDetailMarkupCache.get(caseId);
  }
  const { markup } = await getCaseDetailMarkup(caseId);
  caseDetailMarkupCache.set(caseId, markup);
  return markup;
}

function handleCaseAction(action, row) {
  if (!action || action.disabled) return;
  const caseId = resolveCaseIdentifier(row);
  if (!caseId) return;
  runCaseAction(action.key, caseId);
}
// Table rendering now provided by components/CasesTable

/* TABLE + MODAL HELPERS END */

function attachDetailHeightListeners(section, cell, options = {}) {
  const { force = false } = options;
  if (!cell) return;
  const existingCleanup = detailCellCleanupMap.get(cell);
  if (typeof existingCleanup === 'function') existingCleanup();

  const refresh = () => refreshSectionHeight(section, { force });
  const observer = new MutationObserver(() => refresh());
  observer.observe(cell, { attributes: true, childList: true, subtree: true });

  const handleInteractiveChange = () => {
    refresh();
    setTimeout(refresh, 120);
    setTimeout(refresh, 300);
  };

  cell.addEventListener('click', handleInteractiveChange, true);
  cell.addEventListener('transitionend', handleInteractiveChange, true);
  cell.addEventListener('gov-toggle', handleInteractiveChange, true);

  const cleanup = () => {
    observer.disconnect();
    cell.removeEventListener('click', handleInteractiveChange, true);
    cell.removeEventListener('transitionend', handleInteractiveChange, true);
    cell.removeEventListener('gov-toggle', handleInteractiveChange, true);
  };

  detailCellCleanupMap.set(cell, cleanup);
  refresh();
  setTimeout(refresh, 150);
}

async function renderCasesTableWithData() {
  const container = document.getElementById("moje-rizeni-accordion-active");
  if (!container) return;
  container.innerHTML = "";

  // Fetch cases if not already loaded
  if (allCases.length === 0) {
    try {
      allCases = await fetchRawCases();
    } catch {
      container.textContent = "Chyba při načítání dat.";
      casesTableApi = null;
      refreshSectionHeight(container, { force: true });
      return null;
    }
  }

  // Filter cases based on showClosedCases flag
  let casesToDisplay;
  if (showClosedCases) {
    // Show all cases (active and closed mixed together)
    casesToDisplay = allCases;
  } else {
    // Show only active cases
    casesToDisplay = allCases.filter(
      (obj) => !CLOSED_CASE_STATES.includes(obj.stav)
    );
  }

  if (casesToDisplay.length) {
    casesTableApi = renderCasesTable(container, casesToDisplay, {
      columns: TABLE_COLUMNS,
      initialSortKey: 'datum',
      initialSortDir: 'desc',
      pageSize: 10,
      detailLinkColumnKey: 'cisloRizeni',
      actionsColumnKey: '__actions',
      nonSortableKeys: ['__actions'],
      getRowActions: (row) => {
        // Temporarily hide all action buttons (not ready for production)
        return [];
        // TODO: Re-enable when action functionality is complete
        // if (CLOSED_CASE_STATES.includes(row.stav)) {
        //   return [];
        // }
        // return getCaseActionsFromSource(row);
      },
      onAction: handleCaseAction,
      rowDetailLoader: loadCaseDetailMarkupForRow,
      rowDetailMinLoadMs: CASE_DETAIL_MIN_LOADING_MS,
      resolveRowId: resolveCaseIdentifier,
      onRowToggle: () => refreshSectionHeight(container, { force: true }),
      onRender: () => refreshSectionHeight(container, { force: true }),
      onDetailRender: ({ cell, isLoading }) => {
        if (!cell || isLoading) return;
        attachDetailHeightListeners(container, cell, { force: true });
      }
    });
  } else {
    casesTableApi = null;
    const infoDiv = document.createElement('div');
    infoDiv.className = "no-cases-info";
    infoDiv.textContent = showClosedCases ? "Žádná řízení." : "Žádná probíhající řízení.";
    container.appendChild(infoDiv);
    refreshSectionHeight(container, { force: true });
  }
  return casesTableApi;
}

async function presentCases() {
  // Initial render with only active cases
  await renderCasesTableWithData();

  const checkbox = document.getElementById("ukoncenaRizeniChk");

  // Add event listener once
  if (checkbox && !checkbox._listenerAdded) {
    checkbox.addEventListener("change", async () => {
      showClosedCases = checkbox.checked;
      await renderCasesTableWithData();
    });
    checkbox._listenerAdded = true;
  }
}

function fetchSluzbaSledovaniZmen() {
  fetch("/ssz")
    .then((response) => response.text())
    .then((data) => {
      console.log("fetchSluzbaSledovaniZmen data: " + data);

      const chipzone = document.getElementById("mujkatastrchipzone");
      const sszLinkSubMenu = document.getElementById("ssz-link-submenu");
      
      if (data.length > 0) {
        if (data === "Ano") { // Nezobrazujeme protože je to matoucí, nejde zjistit zda je služba aktivní, mohla být v minulosti zřízena a nyní zrušena
          // if (chipzone) {
          //   const chip = document.createElement("gov-chip");
          //   chip.setAttribute("inverse", "true");
          //   chip.setAttribute("href", "/SszLogin");
          //   chip.setAttribute("target", "_blank");
          //   chip.setAttribute("icon-left", "basic/eye");
          //   chip.setAttribute("icon-right", "basic/check-circle-fill");
          //   chip.setAttribute("variant", "success");
          //   chip.setAttribute("size", "m");
          //   chip.setAttribute("tag", "a");
          //   chip.textContent = "Služba sledování změn: " + data;
          //   chipzone.appendChild(chip);
          // }
          if (sszLinkSubMenu) {
            sszLinkSubMenu.setAttribute("href", "/SszLogin");
          }
        } else {
          if (chipzone) {
            const chipSection = document.createElement("section");
            chipSection.setAttribute("class", "importantMessage");

            const chip = document.createElement("gov-chip");
            chip.setAttribute("inverse", "true");
            chip.setAttribute("href", "/SszZrizeni");
            chip.setAttribute("target", "_blank");
            chip.setAttribute("icon-left", "basic/eye");
            chip.setAttribute("icon-right", "basic/gear-fill");
            chip.setAttribute("variant", "warning");
            chip.setAttribute("size", "m");
            chip.setAttribute("tag", "a");
            chip.textContent = "Služba sledování změn: " + data;
            chipSection.appendChild(chip);
            const text = document.createElement("p");
            text.innerHTML =
              'Pokud chcete být informováni o změnách v katastru u níže uvedených nemovitostí, zřiďte si <a href="/SszZrizeni">službu sledování změn</a>&nbsp;<gov-icon class="mujKatastrTdIcon" type="basic" name="box-arrow-up-right"></gov-icon>. Do dvaceti nemovitostí je služba poskytována bezplatně.';
            chipSection.appendChild(text);
            chipzone.appendChild(chipSection);
          }
          if (sszLinkSubMenu) {
            sszLinkSubMenu.setAttribute("href", "/SszZrizeni");
          }
        }
      }
    });
}

/* TRANSITIONS HELPER FUNCTIONS BEGIN */

function refreshSectionHeight(section, options = {}) {
  if (!section) return;
  const { force = false } = options;
  const apply = () => {
    if (!force && !section.classList.contains('visible')) return;
    const height = section.scrollHeight;
    if (height <= 0) {
      section.style.removeProperty('max-height');
      return;
    }
    section.style.maxHeight = height + 'px';
  };
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(apply);
  } else {
    setTimeout(apply, 0);
  }
  setTimeout(apply, 150);
}

/* TRANSITIONS HELPER FUNCTIONS END */

function initMujKatastr(isPublic) {
  if (isPublic) {
    const loginButtonMujKatastr = document.getElementById("loginButtonMujKatastr");
    if (loginButtonMujKatastr) {
      loginButtonMujKatastr.addEventListener("gov-click", (event) =>
        renderLoginComponent("mujKatastr", event)
      );
    }
  } else {
    presentCases();
    fetchNemovitostiMujPortal();
    fetchJpvProMujPortal();
    fetchMujPortalPoznamkaProOs();
    fetchDalsiZapisyMujPortal();
    fetchSluzbaSledovaniZmen();

  }
}

export { initMujKatastr };